import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { MapPin, Briefcase } from "lucide-react";
import { STATE_MAPPINGS } from "@/lib/stateUtils";

interface StateHubLinksProps {
  stateSlug: string;
  maxLinks?: number;
}

/**
 * Hub links for a state - links to top occupations, no-degree jobs, etc.
 */
export default function StateHubLinks({
  stateSlug,
  maxLinks = 10
}: StateHubLinksProps) {
  const state = STATE_MAPPINGS.find(s => s.slug === stateSlug);
  const stateName = state?.name || stateSlug;

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          Explore {stateName}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <h3 className="font-medium mb-2">Job Opportunities</h3>
            <ul className="space-y-1">
              <li>
                <Link
                  to={`/no-degree-jobs/${stateSlug}/`}
                  className="text-primary hover:underline flex items-center gap-2"
                >
                  <Briefcase className="h-4 w-4" />
                  No-Degree Jobs in {stateName}
                </Link>
              </li>
              <li>
                <Link
                  to={`/best-paying-entry-level/${stateSlug}/`}
                  className="text-primary hover:underline flex items-center gap-2"
                >
                  <Briefcase className="h-4 w-4" />
                  Best Entry-Level Jobs in {stateName}
                </Link>
              </li>
              <li>
                <Link
                  to={`/state/${stateSlug}/`}
                  className="text-primary hover:underline flex items-center gap-2"
                >
                  <MapPin className="h-4 w-4" />
                  All Occupations in {stateName}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

